import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"

const initialState = { status: null, loading: false, data: [], error: "", message: "",totalPages:0 }



export const getAllPartnerRevenueAction = createAsyncThunk(
    'all-partner-revenue-date-wise',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/getAllPartnerDateWise?page=${data?.page}&limit=${data?.pageSize}&s_date=${data?.startDate}&e_date=${data?.endDate}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)   


export const allPartnerSlice = createSlice({
    name: 'all-partner-revenue-date-wise',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getAllPartnerRevenueAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getAllPartnerRevenueAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.totalPages = action?.payload?.totalPages
            })
            builder.addCase(getAllPartnerRevenueAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const dateWiseallPartnersRevenueReducer = allPartnerSlice.reducer